import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const tenantSelectorTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      tenantSelectorBg: theme.color.surface.cool[2],
      tenantSelectorText: theme.color.text.core['-emphasis'],
      headerNavBg: theme.color.surface[2],
      headerNavTitle: theme.color.text.core['-emphasis'],
      headerNavText: theme.color.text.core['-emphasis'],
      headerNavTextActive: theme.color.focus[3],
      headerNavTextDisabled: theme.color.text.core['-tertiary'],
      headerNavSelectedBorder: theme.color.focus[3],
      headerNavBorder: theme.color.surface[2],
    },
  ]),
);
